import React from 'react';
import { Construction } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const Placeholder = ({ title, description }) => {
  return (
    <div className="flex items-center justify-center h-full">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <Construction className="w-16 h-16 text-gray-400" />
          </div>
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description || 'This feature will be available in Part 2'}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-center text-sm text-gray-500">
            Core platform infrastructure is ready. Business features coming in the next phase.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Placeholder;